const DEFAULT_LIMIT = 100;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isUuid(value) {
    return typeof value === 'string' && UUID_PATTERN.test(value);
}
function positiveInt(value, fallback, max) {
    if (value == null || value.trim() === '')
        return fallback;
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < 0)
        return fallback;
    return max == null ? parsed : Math.min(parsed, max);
}
export function readPaymentReviewUrl(params, configuredAlias) {
    const canonicalSelection = params.get('resolution_id');
    const alias = configuredAlias?.trim();
    const rawSelection = canonicalSelection ?? (alias && alias !== 'resolution_id' ? params.get(alias) : null);
    return {
        filters: {
            resolution_id: params.get('filter_resolution_id')?.trim() || undefined,
            order_id: params.get('order_id')?.trim() || undefined,
            transaction_id: params.get('transaction_id')?.trim() || undefined,
            status: params.get('status')?.trim() || undefined,
            limit: Math.max(1, positiveInt(params.get('limit'), DEFAULT_LIMIT, 500)),
            offset: positiveInt(params.get('offset'), 0),
        },
        selectedResolutionId: isUuid(rawSelection) ? rawSelection : null,
        selectionError: rawSelection != null && rawSelection !== '' && !isUuid(rawSelection),
    };
}
const FILTER_PARAMS = {
    resolution_id: 'filter_resolution_id',
    order_id: 'order_id',
    transaction_id: 'transaction_id',
    status: 'status',
    limit: 'limit',
    offset: 'offset',
};
export function writePaymentReviewUrl(current, patch) {
    const next = new URLSearchParams(current);
    if ('selectedResolutionId' in patch) {
        if (patch.selectedResolutionId)
            next.set('resolution_id', patch.selectedResolutionId);
        else
            next.delete('resolution_id');
    }
    if (patch.filters) {
        let changedFilter = false;
        for (const [key, value] of Object.entries(patch.filters)) {
            const param = FILTER_PARAMS[key];
            if (value == null || value === '')
                next.delete(param);
            else
                next.set(param, String(value));
            if (key !== 'offset' && key !== 'limit')
                changedFilter = true;
        }
        if (changedFilter && !('offset' in patch.filters))
            next.set('offset', '0');
    }
    return next;
}
export function buildPaymentReviewLink(settings, resolutionId) {
    const base = settings.admin_ui_base_url?.trim();
    const path = settings.payment_review_path?.trim();
    const parameter = settings.payment_review_id_parameter?.trim();
    if (!base || !path || !parameter || !isUuid(resolutionId))
        return null;
    try {
        const url = new URL(`${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`);
        url.searchParams.set(parameter, resolutionId);
        return url.toString();
    }
    catch {
        return null;
    }
}
